module.exports = __webpack_public_path__ + "img/school-building2.75334d19.svg";